// #region imports

// --- Angular
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

// --- RxJs
import { combineLatest, filter } from 'rxjs';

// --- 3rd Party
import { LanguageDomBaseService } from './language-dom-base.service';
import { LanguagesBaseService } from './languages-base.service';
import { OidcService } from '../account/oidc.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class LanguageDomService extends LanguageDomBaseService {
  constructor(
    @Inject(DOCUMENT) document: Document,
    private languagesService: LanguagesBaseService,
    private oidcService: OidcService) {
    super(document);
  }

  public init(): void {
    this._langChangeSubscription = combineLatest([
      this.languagesService.selectedLanguage$.pipe(filter((language) => language !== null)),
      this.oidcService.isMobileUser$,
    ]).subscribe(([language, isMobileUser]) => {
      this.onLangChange(language, isMobileUser);
    });
  }
}
